const uri:any = {
    getmenus: "/api/APIX/GetMenus",
    GetAuthorizePath: "/api/APIX/GetAuthorizePath",
    AppAuthen: "/api/AppAuthen/",
    }
export default (uri);